class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const endTime = new Date(this.dataset.endTime);

    if (!endTime || isNaN(endTime)) {
      this.innerHTML = '⚠ Invalid date';
      return;
    }

    const pad = (num) => String(num).padStart(2, '0');

    const updateTimer = () => {
      const now = new Date();
      const distance = endTime - now;

      if (distance <= 0) {
        clearInterval(interval);
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days > 0) {
        this.querySelector('[data-days]').innerHTML =
          `<span class="time"><span class="bold">${pad(days)}</span><span class="dates">dni</span></span> <span>:</span> `;
      } else {
        this.querySelector('[data-days]').remove();
      }

      this.querySelector('[data-hours]').innerHTML =
        `<span class="time"><span class="bold">${pad(hours)}</span><span class="dates">godz.</span></span> <span>:</span> `;

      this.querySelector('[data-minutes]').innerHTML =
        `<span class="time"><span class="bold">${pad(minutes)}</span><span class="dates">min</span></span> <span>:</span> `;

      this.querySelector('[data-seconds]').innerHTML =
        `<span class="time"><span class="bold">${pad(seconds)}</span><span class="dates">sek</span></span>`;
    };

    const interval = setInterval(updateTimer, 500);
    updateTimer();
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
